import { render, staticRenderFns } from "./OrderItem.vue?vue&type=template&id=a4042926&scoped=true"
import script from "./OrderItem.vue?vue&type=script&lang=js"
export * from "./OrderItem.vue?vue&type=script&lang=js"
import style0 from "./OrderItem.vue?vue&type=style&index=0&id=a4042926&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4042926",
  null
  
)

export default component.exports